var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetupGuide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 16.5846V3.41797C9.16683 2.16797 8.6335 1.66797 7.3085 1.66797H3.94183C2.61683 1.66797 2.0835 2.16797 2.0835 3.41797V16.5846C2.0835 17.8346 2.61683 18.3346 3.94183 18.3346H7.3085C8.6335 18.3346 9.16683 17.8346 9.16683 16.5846Z",
    fill: "#16342E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9168 9.08463V3.41797C17.9168 2.16797 17.3835 1.66797 16.0585 1.66797H12.6918C11.3668 1.66797 10.8335 2.16797 10.8335 3.41797V9.08463C10.8335 10.3346 11.3668 10.8346 12.6918 10.8346H16.0585C17.3835 10.8346 17.9168 10.3346 17.9168 9.08463Z",
    fill: "#16342E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9168 16.5833V14.25C17.9168 13 17.3835 12.5 16.0585 12.5H12.6918C11.3668 12.5 10.8335 13 10.8335 14.25V16.5833C10.8335 17.8333 11.3668 18.3333 12.6918 18.3333H16.0585C17.3835 18.3333 17.9168 17.8333 17.9168 16.5833Z",
    fill: "#16342E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupGuide);
export default __webpack_public_path__ + "static/media/setupGuide.786863f16cbf303fc8f44f8b94dd3aba.svg";
export { ForwardRef as ReactComponent };